import React from 'react';
import { motion } from 'framer-motion';
import config from '../config';
import { formatDateSk } from '../utils/dates';
import Icon from './Icons';
import './Hero.css';

/**
 * Celoobrazovkový hero s fotografiou, hlavným CTA
 * a odznakom najbližšej dostupnosti.
 * Fotku nahraď v public/images/hero.jpg (ideálne WebP/AVIF variantu tiež).
 */
export default function Hero({ nextAvailableKey }) {
  return (
    <section className="hero" id="uvod">
      <picture className="hero__media">
        {/* Keď nahráš optimalizované varianty do public/images/, odkomentuj:
        <source srcSet="/images/hero.avif" type="image/avif" />
        <source srcSet="/images/hero.webp" type="image/webp" /> */}
        <img
          src="/images/hero.jpg"
          alt={`${config.vehicleName} zaparkovaný v prírode`}
          fetchPriority="high"
        />
      </picture>
      <div className="hero__overlay" aria-hidden="true" />

      <div className="container hero__content">
        <motion.p
          className="hero__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Prenájom VW California v Košiciach
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
        >
          Otoč kľúčom.
          <br />
          Dovolenka začína.
        </motion.h1>

        <motion.p
          className="hero__sub"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          Plne vybavený {config.vehicleName} pre štyroch. Pripravený na víkend
          v horách, cestu k moru aj dovolenku bez pevného itinerára.
          Vyzdvihneš si ho v Šemši pri Košiciach.
        </motion.p>

        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.55 }}
        >
          <a href="#rezervacia" className="btn btn--primary">
            Pozrieť voľné termíny
          </a>
          <a href="#vozidlo" className="btn btn--light">
            Spoznaj Californiu
          </a>
        </motion.div>

        {nextAvailableKey && (
          <motion.a
            href="#rezervacia"
            className="hero__badge"
            aria-label={`Najbližší voľný termín ${formatDateSk(nextAvailableKey)} – prejsť na rezervačný kalendár`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.8 }}
          >
            <Icon name="calendar" size={18} />
            <span>
              Najbližší voľný termín (min. {config.minDays} dni):{' '}
              <strong>{formatDateSk(nextAvailableKey)}</strong>
            </span>
            <Icon name="arrow" size={16} className="hero__badge-arrow" />
          </motion.a>
        )}
      </div>
    </section>
  );
}
